import __request__ from 'routing/request';
type DataLakeInfoArray = DataLakeInfo[];
type FieldInfoArray = FieldInfo[];
interface DataLakeInfo {
    readonly storage_type: 'ICEBERG' | 'TRINO' | 'ATHENA';
    readonly stream_id: string;
    readonly active: boolean;
    readonly id: string;
    readonly type: 'INTERNAL' | 'EXTERNAL';
    readonly title: string;
}
interface FieldInfo {
    readonly class: string;
    readonly filtering: 'DB' | 'IN_MEMORY' | 'NONE';
    readonly field_name: string;
}
/**
 * Get information about active Data Lakes
 */
export function getActive(): Promise<DataLakeInfoArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.datalake/data_lakes/active', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get information about all Data Lakes
 */
export function getAll(): Promise<DataLakeInfoArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.datalake/data_lakes/all', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get information about fields for a given Data Lake
 */
export function getFields(data_lake_id?: string, table_id?: string, exclude_non_filterable: boolean = false, exclude_in_memory_filterable: boolean = false): Promise<FieldInfoArray> {
    return __request__('GET', `/plugins/org.graylog.plugins.datalake/data_lakes/fields/${data_lake_id}`, null, { 'table_id': table_id, 'exclude_non_filterable': exclude_non_filterable, 'exclude_in_memory_filterable': exclude_in_memory_filterable }, {
        'Accept': ['application/json']
    });
}
